// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "LeftNav-module--bx--text-truncate--end--wIttu";
export var bxTextTruncateFront = "LeftNav-module--bx--text-truncate--front--Is0QJ";
export var currentItem = "LeftNav-module--current-item--ieizA";
export var divider = "LeftNav-module--divider--wlFsX";
export var dividerSpace = "LeftNav-module--divider-space--k5D0z";
export var outboundLink = "LeftNav-module--outboundLink--j-dCg";
export var sideNavDark = "LeftNav-module--side-nav--dark--t1s1X";
export var sideNavWhite = "LeftNav-module--side-nav--white--ZHyHD";